import './Section.css';
import SplitLine from '../../SplitLine';

function Section(props) {
  const { title, children } = props;
  return (
    <div className="section">
      <div className="section__title">{title}</div>
      <SplitLine />
      <div className="section__children">{children}</div>
    </div>
  );
}

export default Section;
